import { useJsApiLoader } from '@react-google-maps/api';
import React, { useEffect } from 'react';
import { useContext } from 'react';
import './App.css';
import BlueIconResized from './components/map/blue_icon';
import DropPointsMap from './components/map/map';
import MarkerDetail from './components/search/marker_detail';
import SearchHeading from './components/search/search_heading';
import { AppWrapper } from './components/wrappers/app_wrapper';
import { DropPointsWrapper } from './components/wrappers/drop_points_wrapper';
import { MapWrapper } from './components/wrappers/map_wrapper';
import { SearchWrapper } from './components/wrappers/search_wrapper';
import { getDropPoints } from './services/services';
import { Context } from './store/context';

const libraries = ['drawing', 'geometry', 'places'];

function App() {
  const {
    map,
    activeMarkerId,
    bounds,
    dropPoints,
    mapMarkers,
    setDroppoints,
    setBounds,
    setLastCenter,
  } = useContext(Context);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    libraries: libraries,
    // eslint-disable-next-line no-undef
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const loadMarkers = async () => {
    let dropPoints = await getDropPoints();
    setDroppoints(dropPoints || []);
  };

  useEffect(() => {
    loadMarkers();
  }, []);

  useEffect(() => {
    mapMarkers.forEach((marker) => {
      if (marker.id === activeMarkerId) {
        new window.google.maps.event.trigger(marker, 'click');
      } else {
        marker.setIcon(BlueIconResized);
      }
    });
  }, [activeMarkerId]);

  return (
    <>
      <AppWrapper>
        <SearchWrapper>
          <SearchHeading
            title="Busqueda de punto Droop"
            description="Usa los puntos de referencia o dirección de la zona donde quieres encontrar un punto Droop"
            subdescription="Ubicación o referencia"
            isLoaded={isLoaded}
          />
          <DropPointsWrapper>
            {dropPoints
              .filter((point) => {
                let marker = mapMarkers.find((x) => x.id === point.id);
                if (marker) {
                  return map?.getBounds()?.contains(marker.getPosition());
                }
                return false;
              })
              .map((point) => {
                return (
                  <MarkerDetail
                    key={`${point.id}`}
                    id={`${point.id}`}
                    title={point.label}
                    direction={point.direccion}
                    schedule={point.horario}
                    phone={point.telefono}
                    lat={point.lat}
                    lng={point.lng}
                  ></MarkerDetail>
                );
              })}
          </DropPointsWrapper>
        </SearchWrapper>
        <MapWrapper>
          <DropPointsMap
            dropPoints={dropPoints}
            isLoaded={isLoaded}
            onBoundsChanged={() => {
              if (map) setLastCenter(map.getCenter());
              setBounds(bounds + 1);
            }}
          />
        </MapWrapper>
      </AppWrapper>
    </>
  );
}

export default App;
